import type { IngestResponse, ReportPayload } from "@ark-snitch/shared";

export interface SubmitArgs {
  endpoint: string;
  apiKey: string;
  title: string;
  note: string;
  payload: ReportPayload;
  screenshot?: File | null;
  voiceNote?: File | null;
  screenRecording?: File | null;
}

export class IngestError extends Error {
  constructor(
    message: string,
    public status: number,
    public body?: string,
  ) {
    super(message);
    this.name = "IngestError";
  }
}

export const submitReport = async (args: SubmitArgs): Promise<IngestResponse> => {
  const url = new URL("/api/snitch/ingest", args.endpoint).toString();

  const form = new FormData();
  form.set("title", args.title);
  form.set("note", args.note);
  form.set("payload", JSON.stringify(args.payload));
  if (args.screenshot) form.set("screenshot", args.screenshot, args.screenshot.name);
  if (args.voiceNote) form.set("voice_note", args.voiceNote, args.voiceNote.name);
  if (args.screenRecording)
    form.set("screen_recording", args.screenRecording, args.screenRecording.name);

  const res = await fetch(url, {
    method: "POST",
    headers: { "X-Snitch-Key": args.apiKey },
    body: form,
    credentials: "omit",
    mode: "cors",
  });

  const text = await res.text();
  if (!res.ok) {
    throw new IngestError(
      `ingest failed (${res.status})`,
      res.status,
      text,
    );
  }
  try {
    return JSON.parse(text) as IngestResponse;
  } catch {
    throw new IngestError(
      "ingest returned non-JSON response",
      res.status,
      text,
    );
  }
};
